// extracted by mini-css-extract-plugin
module.exports = {"paramTitle":"Param_paramTitle__2uxj5","paramName":"Param_paramName__1P2ya","paramValue":"Param_paramValue__1tSKO"};